/* import __COLOCATED_TEMPLATE__ from './complete.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { Country } from '@square/dashboard-protos/models/squareup/common/countries';
import { ProductName } from '@banking/ui/models/checking/product-positioning';
import countryTranslationKey from '@banking/ui/utils/checking/country-translation-key';
import productNameTranslationKey from '@banking/ui/utils/checking/product-name-translation-key';
import { tracked } from '@glimmer/tracking';
import { BalanceActivityEntityIdentifier, BalanceActivityType } from '@square/dashboard-protos/models/squareup/deposits/model';
export let CTA = /*#__PURE__*/function (CTA) {
  CTA[CTA["Default"] = 0] = "Default";
  CTA[CTA["Alternative"] = 1] = "Alternative";
  return CTA;
}({});
let Complete = (_class = class Complete extends Component {
  constructor(owner, args) {
    super(owner, args);
    _defineProperty(this, "CTA", CTA);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "userInfo", _descriptor2, this);
    _initializerDefineProperty(this, "externalDepositsApi", _descriptor3, this);
    _initializerDefineProperty(this, "isPauseSettlement", _descriptor4, this);
    _initializerDefineProperty(this, "transferFeeBasisPoints", _descriptor5, this);
    _initializerDefineProperty(this, "sentry", _descriptor6, this);
    const searchParams = new URLSearchParams(window.location.search);
    const unitToken = searchParams.get('unitToken') || this.userInfo.unitToken;
    try {
      this.externalDepositsApi.client.getDepositSchedule({
        unitToken
      }).then(res => {
        this.isPauseSettlement = res.currentWeeklyDepositSchedule.pausedSettlement;
      });
      this.externalDepositsApi.client.getTransferFeeDetails({
        sourceId: BalanceActivityEntityIdentifier.create({
          unitToken
        }),
        transferType: BalanceActivityType.INSTANT_PAYOUT
      }).then(res => {
        this.transferFeeBasisPoints = res.feeBasisPoints;
      });
    } catch (error) {
      this.sentry.captureException(error);
    }
  }
  get countryCode() {
    return this.userInfo.countryCode;
  }
  get transferSpeed() {
    switch (this.countryCode) {
      case 'CA':
        return this.intl.t('banking.checking.onboarding.complete.transferSpeed.CA');
      case 'GB':
        return this.intl.t('banking.checking.onboarding.complete.transferSpeed.GB');
      case 'US':
      default:
        return this.intl.t('banking.checking.onboarding.complete.transferSpeed.default');
    }
  }
  get transferAmountPercentage() {
    if (this.transferFeeBasisPoints) {
      return `${this.transferFeeBasisPoints / 100}%`;
    }
    return '';
  }
  get header() {
    return this.intl.t(productNameTranslationKey(this.args.productName, 'banking.checking.onboarding.complete.header'));
  }
  get description() {
    return this.intl.t(countryTranslationKey(Country[this.userInfo.countryCode], 'banking.checking.onboarding.complete.description'));
  }
  get subHeader() {
    if (!this.isPauseSettlement) {
      return this.intl.t('banking.checking.onboarding.complete.subHeader.automatic');
    } else {
      switch (this.args.productName) {
        case ProductName.CheckingAndDebit:
          return this.intl.t('banking.checking.onboarding.complete.subHeader.manual');
        default:
          return '';
      }
    }
  }
  get nextButtonCTA() {
    return this.intl.t(productNameTranslationKey(this.args.productName, 'banking.checking.onboarding.complete.nextButtonCTA'));
  }
  get salesToCheckingTitle() {
    switch (this.args.productName) {
      case ProductName.CheckingAndDebit:
        return this.intl.t('banking.checking.onboarding.complete.salesToChecking.title');
      default:
        return '';
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "externalDepositsApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isPauseSettlement", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "transferFeeBasisPoints", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { Complete as default };